































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import SelectChannelModal from "@/components/channels/modals/SelectChannelModal.vue";
// types
import { Settings } from "@/services/backgrounds/types";
// validation
import validate from "@/directives/validate";
import { settingsValidators } from "@/components/backgrounds/validators";

@Component({
    components: {
        SelectChannelModal
    },
    directives: {
        validate
    }
})
export default class BackgroundSettings extends Vue {
    @Prop() settings!: Settings;
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localSettings = { backgroundBaseId: "", backgroundBaseName: "" } as Settings;
    validators = settingsValidators;
    validateBackgroundFill = false;
    // Watchers
    @Watch("settings")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localSettings = this.settings;
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }
    // computed

    // methods
    addBackgroundBase() {
        (this.$refs.selectChannelModal as any).open();
    }

    // events && callbacks
    channelSelected(channel: any) {
        this.localSettings.backgroundBaseName = channel[0].name;
        this.localSettings.backgroundBaseId = channel[0].id;
    }

    emitData() {
        this.validateBackgroundFill = true;
        this.$emit("settingsUpdated", JSON.stringify(this.localSettings));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "BackgroundSettings", state: state });
    }

    goToContentRoute() {
        return {
            name: "updatechannel",
            params: { channelId: this.localSettings.backgroundBaseId }
        };
    }
}
